<template>
    <div class="d-flex justify-content-center align-items-center mt-5 mb-5">
      <md-progress-spinner class="mt-5 mb-5" :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
    </div>
</template>

<script>
    export default {
        name: "LazyLoadPage"
    }
</script>

<style scoped>

</style>
